import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 上传方案表格
export function importReconciliationBill(form) {
  const data = new FormData()
  for (const key in form) {
    data.append(key, form[key])
  }
  return request({
    url: URL.act.reconciliation.importReconciliationBill,
    method: 'post',
    data
  })
}

// 自动对账详情
export function queryReconciliationList(form) {
  const data = new FormData()
  for (const key in form) {
    data.append(key, form[key])
  }
  return request({
    url: URL.act.reconciliation.queryReconciliationList,
    method: 'post',
    data
  })
}

// 手工对账
export function manualReconciliation(form) {
  const data = new FormData()
  for (const key in form) {
    data.append(key, form[key])
  }
  return request({
    url: URL.act.reconciliation.manualReconciliation,
    method: 'post',
    data
  })
}

// 取消手工对账
export function cancleManualReconciliation(form) {
  const data = new FormData()
  for (const key in form) {
    data.append(key, form[key])
  }
  return request({
    url: URL.act.reconciliation.cancleManualReconciliation,
    method: 'post',
    data
  })
}

// 详情保存对账
export function detailSaveReconciliation(form) {
  const data = new FormData()
  for (const key in form) {
    data.append(key, form[key])
  }
  return request({
    url: URL.act.reconciliation.detailSaveReconciliation,
    method: 'post',
    data
  })
}

// 详情
export function checkAccount(form) {
  const data = new FormData()
  for (const key in form) {
    data.append(key, form[key])
  }
  return request({
    url: URL.act.reconciliation.checkAccount,
    method: 'post',
    data
  })
}

// 导出
export function exportReconciliation(form) {
  const data = new FormData()
  for (const key in form) {
    data.append(key, form[key])
  }
  return request({
    url: URL.act.reconciliation.exportReconciliation,
    method: 'post',
    responseType: 'blob',
    data
  })
}

// 导出外部
export function exportReconciliationInternal(form) {
  const data = new FormData()
  for (const key in form) {
    data.append(key, form[key])
  }
  return request({
    url: URL.act.reconciliation.exportReconciliationInternal,
    method: 'post',
    responseType: 'blob',
    data
  })
}
